import template from "./index.html";
import "./index.less";
import { EVENT_LOGOUT } from "../../../constants";
import marked from "marked";

export function controller($scope, eventBus, $logger, $sce, agreementService) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.$onDestroy = this.accept;

	function onInit() {
		eventBus.register(EVENT_LOGOUT, () => { this.accept(); }, $scope);

		ctrl.title = ctrl.resolve?.agreement?.Content.Title ?? "Form Use Acceptance";
		ctrl.isLegacyModal = ctrl.resolve?.agreement?.Content === undefined;
		ctrl.isPlainText = (ctrl.resolve?.agreement?.Content.Type.Code ?? "").toLowerCase() === "text/plain";
		ctrl.formAcceptance = getTrustedContent();
	}

	function getTrustedContent() {
		const agreementContent = ctrl.resolve?.agreement?.Content;

		const content = agreementContent?.Content ?? ctrl.resolve?.nomenclature?.FormUseAcceptance ?? "";
		const contentType = (agreementContent?.Type.Code ?? "text/markdown").toLowerCase();

		if(contentType === "text/plain") {
			return content;
		}

		if(contentType === "text/html") {
			return $sce.trustAsHtml(content);
		}

		return $sce.trustAsHtml(marked(content));
	}

	ctrl.decline = async() => {
		if(!ctrl.isLegacyModal) {
			const requirementCodes = ctrl.resolve?.agreement?.RequirementCodes ?? [];
			const agreement = ctrl.resolve?.agreement;
			if(!agreement) {
				$logger.error("No agreement was selected", { resolve: ctrl.resolve });
				return Promise.reject(new Error("Notice not found"));
			}

			if(requirementCodes.indexOf("SIGN") >= 0 || requirementCodes.indexOf("AFFIRM") >= 0) {
				await agreementService.rejectAgreement(agreement.AgreementVersion.Id);
			}
		}
		ctrl.modalInstance.dismiss();
	};

	ctrl.close = async() => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.accept = async(shouldPersistAcceptance = false) => {
		if(ctrl.isLegacyModal) {
			ctrl.modalInstance.close(shouldPersistAcceptance);
		}
		else {
			const requirementCodes = ctrl.resolve?.agreement?.RequirementCodes ?? [];
			const agreement = ctrl.resolve?.agreement;
			if(!agreement) {
				$logger.error("No agreement was selected", { resolve: ctrl.resolve });
				return Promise.reject(new Error("Notice not found"));
			}

			if(requirementCodes.indexOf("SIGN") >= 0) {
				await agreementService.signAgreement(agreement.AgreementVersion.Id);
			}
			else if(requirementCodes.indexOf("AFFIRM") >= 0) {
				await agreementService.affirmAgreement(agreement.AgreementVersion.Id);
			}
			ctrl.modalInstance.close(true);
		}
	};

	ctrl.acceptAlways = () => {
		ctrl.accept(true);
	};
}

export default angular
	.module("vesl.components.agreement-display-modal", [])
	.component("agreementDisplayModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
